module.exports = __webpack_public_path__ + "fd46539044c0c15339fbc184430c21a7.jpg";


//////////////////
// WEBPACK FOOTER
// ../assets/img/posts/blog-handshake.jpg
// module id = 479
// module chunks = 0